import { useTranslation } from 'react-i18next'

import { SubpageFoodCostHeader } from '@/components/food-cost/SubpageFoodCostHeader'
import { listRoutableNewsArticles } from '@/features/actualidad-hostelera/articleBodies'
import { newsArticlePath } from '@/features/actualidad-hostelera/articles'
import { NewsletterSubscribe } from '@/features/newsletter/NewsletterSubscribe'
import { LocaleSeoLinks } from '@/navigation/LocaleSeoLinks'
import { ROUTES } from '@/navigation/constants'
import { absoluteLocalizedUrl } from '@/navigation/locale'
import { useLandingLocale } from '@/navigation/useLandingLocale'
import { articleHub } from '@/shared/lib/articleHubStyles'
import { DEFAULT_SHARE_IMAGE } from '@/shared/lib/siteSeo'
import { ArticleHubListing } from '@/shared/ui/ArticleHubListing'
import { Footer } from '@/shared/ui/Footer'
import { PageHelmet } from '@/shared/ui/PageHelmet'
import { SocialShareMeta } from '@/shared/ui/SocialShareMeta'
import '@/styles/food-cost-fonts.css'

export function NewsPage() {
    const { t, i18n } = useTranslation()
    const locale = useLandingLocale()
    const articles = listRoutableNewsArticles(locale)

    const title = t('newsPage.meta.title', 'Actualidad hostelera | Noticias para hostelería')
    const description = t(
        'newsPage.meta.description',
        'Noticias, ayudas y novedades del sector hostelero explicadas con claridad para dueños de bares y restaurantes.',
    )
    const canonicalUrl = absoluteLocalizedUrl(ROUTES.news, locale)

    return (
        <div className={articleHub.page}>
            <LocaleSeoLinks path={ROUTES.news} locale={locale} />
            <SocialShareMeta
                title={title}
                description={description}
                imageUrl={DEFAULT_SHARE_IMAGE}
                url={canonicalUrl}
            />
            <PageHelmet locale={locale}>
                <title>{title}</title>
                <meta name='description' content={description} />
                <link
                    rel='preload'
                    href='/fonts/Archivo/archivo-latin.woff2'
                    as='font'
                    type='font/woff2'
                    crossOrigin='anonymous'
                />
            </PageHelmet>

            <SubpageFoodCostHeader />

            <main className={articleHub.main}>
                <div className={articleHub.header}>
                    <div className={articleHub.headerCopy}>
                        <div className={articleHub.eyebrow}>{t('newsPage.eyebrow')}</div>
                        <h1 className={articleHub.title}>{t('newsPage.title')}</h1>
                    </div>
                    <p className={articleHub.intro}>{t('newsPage.intro')}</p>
                </div>

                <ArticleHubListing
                    articles={articles}
                    articlePath={newsArticlePath}
                    locale={i18n.language}
                    readingMinutesLabel={count =>
                        t('newsPage.readingMinutes', {
                            count,
                            defaultValue: `${count} min de lectura`,
                        })
                    }
                    readArticleLabel={t('newsPage.readArticle')}
                    imageObjectClass='object-top'
                />
            </main>

            <NewsletterSubscribe variant='hub' hub='actualidad' source='hub/actualidad-hostelera' />

            <Footer landingPage='news' className='border-article-cream/10 bg-article-shell' />
        </div>
    )
}
